import React, { useState, useEffect } from "react";
import Nav from "app/components/Nav";
import socketIOClient from "socket.io-client";
import constant from "../../../utils/constants";
import CarbonMetalProcess from "./components/CarbonMetalProcess";
import Scenario from "./components/Scenario";
import CarbonMetalCalculator from "./components/CarbonMetalCalculator";
import "../styles/styles.css";
import "../CarbonCalculator/components/styles.css";
import { useRecoilValue } from "recoil";
import { CostData, ButtonRenderState } from "atoms/CostToCarbonData";
import CurrentReports from "./components/CurrentReports";
import Analytics from "../Analytics";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useRecoilState } from "recoil";
import { ProcessFlag } from "atoms/General";
import ConsultingTeam from "app/components/ConsultingTeam.jsx";
import { Dropdown } from "react-bootstrap";

const CCCarbonMetal = () => {
  const [step, setStep] = useState("process");
  const [socket, setSocket] = useState();
  const costData = useRecoilValue(CostData);
  const [processFlag, setProcessFlag] = useRecoilState(ProcessFlag);
  const [email, setEmail] = useState();
  const [typedocument, setTypeDocument] = useState();
  const [show, setShow] = useState(false);

  useEffect(() => {
    const socketOb = new socketIOClient(constant.uri);
    const patch = require("socketio-wildcard")(socketIOClient.Manager);
    patch(socketOb);
    const socketObj = socketOb;
    setSocket(socketObj);
  }, []);

  const getPreviousStep = (current) => {
    if (current === "carbonpricing") return "process";
    if (current === "scenario") return "carbonpricing";
    // if (current === "visual") return "scenario";
    // if (current === "reports") return "visual";
    return "process";
  };

  const getNextStep = (current) => {
    if (current === "process") return "carbonpricing";
    if (current === "carbonpricing") return "scenario";
    if (current === "scenario") return "visual";
    // if (current === "visual") return "reports";
    return current;
  };

  const canProceed = (current) => {
    if (current === "process") return !!processFlag.Transportation;
    if (current === "carbonpricing") return !!processFlag.CarbonPricing;
    if (current === "scenario") return !!processFlag.ScenarioAnalysis;
    if (current === "visual") return !!processFlag.ScenarioAnalysis;
    else return true;
  };

  const handleBack = () => {
    if (step === "process") {
      window.location.href = "/";
    } else {
      setStep(getPreviousStep(step));
    }
  };

  const handleNext = () => {
    if (canProceed(step)) {
      if (step === "scenario") {
        window.location.href = "/calculator/visual-analytics/true";
      } else {
        setStep(getNextStep(step));
      }
    } else {
      toast.error(`Please fill all ${step} details.`);
    }
  };

  const handleShow = () => setShow(true);

  return (
    <React.Fragment>
      <ToastContainer />
      <Nav />
      <div className="row  ">
        <div className="col page-container px-0">
          <div className="ccsteps-container">
            <div className="bar">
              <div className="row progress-holder "> 
                {/* Process */}
                <div
                  className={
                    "progress-stage deadcenter " +
                    (step === "process" ? " arrow-back" : "")
                  }
                  // onClick={() => {
                  //   setStep("process");
                  // }}
                >
                  <div className="stage ">
                    <img
                      alt=""
                      className="icon-image"
                      id="image-process"
                      src={
                        step === "process"
                          ? "../assets/process-selected.png"
                          : "../assets/process.png"
                      }
                      width="24"
                      height="20"
                    />
                    <p className="d-flex">Process</p>
                  </div>
                </div>

                {/* Carbon Pricing */}
                <div
                  className={
                    "progress-stage deadcenter " +
                    (step === "carbonpricing" ? " arrow-back" : "")
                  }
                  // onClick={() => {
                  //   if (processFlag.Transportation) {
                  //     setStep("carbonpricing");
                  //   } else {
                  //     toast.error("Please fill all process details.");
                  //   }
                  // }}
                >
                  <div className="stage ">
                    <img
                      alt=""
                      className="icon-image"
                      id="image-carbonpricing"
                      src={
                        step === "carbonpricing"
                          ? "../assets/carbon-selected.png"
                          : "../assets/carbon.png"
                      }
                      width="24"
                      height="20"
                    />
                    <p className="d-flex">Carbon Pricing</p>
                  </div>
                </div>

                {/* Scenarios */}
                <div
                  className={
                    "progress-stage deadcenter " +
                    (step === "scenario" ? " arrow-back" : "")
                  }
                  // onClick={() => {
                  //   if (processFlag.CarbonPricing) {
                  //     setStep("scenario");
                  //     setProcessFlag((prevState) => {
                  //       return {
                  //         ...prevState,
                  //         ScenarioAnalysis: true,
                  //       };
                  //     });
                  //   } else {
                  //     toast.error("Please fill all carbon pricing details.");
                  //   }
                  // }}
                >
                  <div className="stage ">
                    <img
                      alt=""
                      className="icon-image"
                      id="image-scenario"
                      src={
                        step === "scenario"
                          ? "../assets/scenarios-selected.png"
                          : "../assets/scenarios.png"
                      }
                      width="24"
                      height="20"
                    />
                    <p className="d-flex">Scenarios</p>
                  </div>
                </div>

                {/* Visual Analytics */}
                {/* <div
                  className={
                    "progress-stage deadcenter " +
                    (step === "visual" ? " arrow-back" : "")
                  }
                  // onClick={() => {
                  //   if (processFlag.ScenarioAnalysis) {
                  //     setStep("visual");
                  //   } else {
                  //     toast.error("Please fill all scenario analysis details.");
                  //   }
                  // }}
                >
                  <div className="stage ">
                    <img
                      alt=""
                      className="icon-image"
                      id="image-visual"
                      src={
                        step === "visual"
                          ? "../assets/analytics.png"
                          : "../assets/analytics.png"
                      }
                      width="24"
                      height="20"
                    />
                    <p className="d-flex">Visual Analytics</p>
                  </div>
                </div> */}

                {/* Reports */}
                {/* <div
                  className={
                    "progress-stage deadcenter " +
                    (step === "reports" || step === "reportstwo"
                      ? " arrow-back"
                      : "")
                  }
                  // onClick={() => {
                  //   if (processFlag.ScenarioAnalysis) {
                  //     setStep("reports");
                  //   } else {
                  //     toast.error("Please fill all visual analytics details.");
                  //   }
                  // }}
                >
                  <div className="stage ">
                    <img
                      alt=""
                      className="icon-image"
                      id="image-reports"
                      src={
                        step === "reports" || step === "reportstwo"
                          ? "../assets/report-selected.png"
                          : "../assets/report1.png"
                      }
                      width="24"
                      height="20"
                    />
                    <p className="d-flex">Reports</p>
                  </div>
                </div> */}
              </div>
            </div>

            {/* Old button navigation - commented out */}
            {/* <div className="ccsteps-section">
              <button
                onClick={() => setStep("process")}
                className={
                  step === "process"
                    ? "selection-button m-0"
                    : "selection-button unselected-btn m-0"
                }
              >
                Process
              </button>
              <button
                onClick={() => {
                  if (processFlag.Transportation) {
                    setStep("carbonpricing");
                  } else {
                    toast.error("Please fill all process details.");
                  }
                }}
                className={
                  step === "carbonpricing"
                    ? "selection-button"
                    : "selection-button unselected-btn"
                }
              >
                Carbon Pricing
              </button>
              <button
                onClick={() => {
                  if (processFlag.CarbonPricing) {
                    setStep("scenario");
                    setProcessFlag((prevState) => {
                      return {
                        ...prevState,
                        ScenarioAnalysis: true,
                      };
                    });
                  } else {
                    toast.error("Please fill all carbon pricing details.");
                  }
                }}
                className={
                  step === "scenario"
                    ? "selection-button"
                    : "selection-button unselected-btn"
                }
              >
                Scenarios
              </button>
              <button
                onClick={() => {
                  if (processFlag.ScenarioAnalysis) {
                    setStep("visual");
                  } else {
                    toast.error("Please fill all scenario analysis details.");
                  }
                }}
                className={
                  step === "visual"
                    ? "selection-button"
                    : "selection-button unselected-btn"
                }
              >
                Visual Analytics
              </button>
              <button
                onClick={() => {
                  if (processFlag.ScenarioAnalysis) {
                    setStep("reports");
                  } else {
                    toast.error("Please fill all visual analytics details.");
                  }
                }}
                className={
                  step === "reports"
                    ? "selection-button"
                    : step === "reportstwo"
                      ? "selection-button "
                      : "selection-button unselected-btn"
                }
              >
                Reports
              </button>
            </div> */}

            <div className="container-form row p-0" style={{
              minHeight:"calc(100vh - 291px)"
            }}>
            {step === "process" && (
              <CarbonMetalProcess
                socket={socket}
                staticDataOfMachine={costData}
                ScenarioState={() => setStep("carbonpricing")}
              />
            )}
            {step === "scenario" && (
              <Scenario
                socket={socket}
                staticDataOfMachine={costData}
                ScenarioState={() => setStep("visual")}
              />
            )}
            {step === "visual" && (
              <Analytics ScenarioState={() => setStep("reports")} />
            )}
            {step === "reports" && (
              <CurrentReports
                socket={socket}
                staticDataOfMachine={costData}
                ScenarioState={() => setStep("reportstwo")}
                setEmail={setEmail}
                setTypeDocument={setTypeDocument}
                typedocument={typedocument}
                setShow={setShow}
                show={show}
                email={email}
              />
            )}
            {step === "carbonpricing" && (
              <CarbonMetalCalculator
                socket={socket}
                staticDataOfMachine={costData}
                ScenarioState={() => setStep("scenario")}
              />
            )}
            </div>

            <div className="border-top mt-24">
              <div className="d-flex mx-80 my-12   justify-content-between">
                <>
                  <div className="d-flex ">
                    <div id="btn-row ">
                      <div
                        className="button1 button btn-black"
                        onClick={handleBack}
                      >
                        <p>Back</p>
                      </div>
                    </div>
                  </div>
                  {step==="reports"?(
                    <div className="d-flex justify-content-center align-items-center gap-8">
                    <Dropdown>
                      <Dropdown.Toggle
                        className="button1 button btn-black "
                        id="dropdown-basic"
                        style={{backgroundColor:"black"}}
                      >
                       <div className='d-flex gap-8'>
                          <img alt=""  src="../assets/download.svg" />
                          <span>Download</span>
                          </div>
                      </Dropdown.Toggle>
          
                      <Dropdown.Menu>
                        <Dropdown.Item
                          onClick={() => {
                            setTypeDocument(0);
                            handleShow()
                          }}
                        >
                          As Pdf
                        </Dropdown.Item>
                        <Dropdown.Item
                          onClick={() => {
                            setTypeDocument(1);
                            handleShow()
                          }}
                        >
                          As Word
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                    <ConsultingTeam navigate={email} />

                  </div>
                  ):(
                  
                  <div>
                    <div id="btn-row">
                      <div
                        className="button1 button btn-primary"
                        onClick={handleNext}
                      >
                        <p>Next</p>
                      </div>
                    </div>
                  </div>
                  )}
                </>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default CCCarbonMetal;
